import { createSelector } from 'reselect'

export const getHeartbeats = (state, props) => {
  return state.kanbo.heartbeats
}

export const timeoutHeartbeatSelector = createSelector(
  [
    getHeartbeats
  ],
  (
    heartbeats
  ) =>
    heartbeats.reduce((timeoutHearbeat, heartbeat) => {
      if (
        heartbeat.timestamp && (
          !timeoutHearbeat ||
          heartbeat.timestamp < timeoutHearbeat.timestamp
        )
      ) {
        return {
          ...heartbeat
        }
      }

      return timeoutHearbeat
    }, undefined)
)

export default createSelector(
  [
    timeoutHeartbeatSelector
  ],
  (
    timeoutHeartbeat
  ) => ({
    timeoutHeartbeat
  })
)
